module.exports = __webpack_public_path__ + "static/img/brand4.c5739ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand4.png
// module id = qBlk
// module chunks = 1